/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import * as types from './mutation-types'
import Vue from 'vue'

export const store = ({ commit }, catalogs) => {
  commit(types.STORE, catalogs)
}

export const create = ({ commit }, catalog) => {
  commit(types.CREATE, catalog)
}

export const update = ({ commit }, catalog) => {
  commit(types.UPDATE, catalog)
}
export const del = ({ commit }, catalog) => {
  commit(types.DELETE, catalog)
}

export default {
  create,
  update,
  store,
  delete: del,
}


// WEBPACK FOOTER //
// ./src/store/modules/catalogs/actions.js